module.exports = __webpack_public_path__ + "images/003837ff1263bcf2145901cdfa442daa.png";